module.exports = __webpack_public_path__ + "static/img/1.b9ea74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newTwo/1.png
// module id = +D4B
// module chunks = 0